export default __webpack_public_path__ + "38ddf942de2c2d1e8948c42982d55ba4.coffee";